import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=5d35cc64&scoped=true&style=display%3A%20flex%3B"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=5d35cc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d35cc64",
  null
  
)

export default component.exports